// App.js

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import Stats from './components/stats';
import Login from './components/Login';
import Registration from './components/Registration';
//import PlayerReviews from './components/PlayerReviews';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import Profilesettings from './components/profile-settings';
import Feedback from './components/feedback';
import Games from './components/Games';
import Leaderboard from './components/Leaderboards';
import Instructions from './components/Instructions';
import Game2048 from './components/GameHub/Game2048/Game2048';
import BrickMania from './components/GameHub/BrickMania';
import Sodoku from './components/GameHub/Sodoku/SodokuGame';
import WordSearch from './components/GameHub/WordSearch/wordSearch';
import WhackAMole from './components/GameHub/WhackAMole/whackAMole';
import Tetris from './components/GameHub/Tetris/comp/Tetris/Tetris';
import SnakeGame from './components/GameHub/SnakeGame/SnakeGame';
import WordScramble from './components/GameHub/WordScramble/WordScramble';
import ShooterGame from './components/GameHub/ShootingGame/Shootergame';
import MarioJump from './components/GameHub/MarioJump/MarioJump';
import MatchingGame from './components/GameHub/MatchingGame/MatchingGame';
import GameOverScreen from './components/GameHub/GameOverScreen';
import TestComponent from './components/TestComponent';
import './App.css';

function App() {
    // Retrieve the theme preference from local storage, defaulting to dark mode if not set
    const [isLightMode, setIsLightMode] = useState(() => {
        return localStorage.getItem('theme') === 'light' ? true : false;
    });

    // Function to toggle theme and save the preference in local storage
    const toggleTheme = () => {
        setIsLightMode((prevMode) => {
            const newMode = !prevMode;
            localStorage.setItem('theme', newMode ? 'light' : 'dark'); // Save the theme in local storage
            return newMode;
        });
    };



    return (
        <Router>
            <div className={`App ${isLightMode ? "light-mode" : ""}`}>
                <Navbar isLightMode={isLightMode} toggleTheme={toggleTheme} />
                <Routes>
                    <Route path="/" element={<><Dashboard /><FAQ /></>} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/registration" element={<Registration />} />
                    <Route path="/profile-settings" element={<Profilesettings />} />
                    <Route path="/feedback" element={<Feedback />} />
                    <Route path="/games" element={<Games />} />
                    <Route path="/leaderboards" element={<Leaderboard />} />
                    <Route path="/stats" element={<Stats />} />
                    <Route path="/instructions/:gameId" element={<Instructions />} />
                    <Route path="/2048" element={<Game2048 />} />
                    <Route path="/brickmania" element={<BrickMania />} />
                    <Route path="/sodoku" element={<Sodoku />} />
                    <Route path="/wordsearch" element={<WordSearch />} />
                    <Route path="/whack" element={<WhackAMole />} />
                    <Route path="/tetris" element={<Tetris />} />
                    <Route path="/snake" element={<SnakeGame />} />
                    <Route path="/word-scramble" element={<WordScramble />} />
                    <Route path="/shooter" element={<ShooterGame />} />
                    <Route path="/mario" element={<MarioJump />} />
                    <Route path="/matching" element={<MatchingGame />} />
                    <Route path="/test" element={<TestComponent />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
